module.exports = __webpack_public_path__ + "static/media/speech.ce4cd1a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/speech.svg
// module id = 1059
// module chunks = 0